import { BlockBlobClient } from '@azure/storage-blob';

const DEFAULT_BLOCK_SIZE_BYTES = 8 * 1024 * 1024;
const DEFAULT_CONCURRENCY = 4;

type BlobUploadClient = {
  uploadData: (
    data: Blob,
    options: {
      blockSize: number;
      concurrency: number;
      blobHTTPHeaders: { blobContentType: string };
      abortSignal?: AbortSignal;
      onProgress?: (event: { loadedBytes: number }) => void;
    }
  ) => Promise<unknown>;
};

export type DirectBlobUploadOptions = {
  blockSizeBytes?: number;
  concurrency?: number;
  abortSignal?: AbortSignal;
  onProgress?: (progress: number) => void;
  createClient?: (uploadUrl: string) => BlobUploadClient;
};

export async function uploadFileToBlob(
  uploadUrl: string,
  file: File,
  options: DirectBlobUploadOptions = {}
): Promise<void> {
  const client =
    options.createClient?.(uploadUrl) ?? new BlockBlobClient(uploadUrl);
  const blockSize = options.blockSizeBytes ?? DEFAULT_BLOCK_SIZE_BYTES;
  const concurrency = options.concurrency ?? DEFAULT_CONCURRENCY;

  await client.uploadData(file, {
    blockSize,
    concurrency,
    abortSignal: options.abortSignal,
    blobHTTPHeaders: {
      blobContentType: file.type || 'application/octet-stream'
    },
    onProgress: (event) => {
      if (!options.onProgress || file.size <= 0) {
        return;
      }

      const progress = (event.loadedBytes / file.size) * 100;
      options.onProgress(Math.min(Math.round(progress), 99));
    }
  });

  options.onProgress?.(99);
}
